<app-base-modal [showClose]="showClose" (closeCross)="onCloseModal()">
  <ng-container modal-body-content>
    <div class="learning-image-modal-content">
      @if (imageUrl) {
        <img [src]="imageUrl" [alt]="imageAlt || 'Image'" />
      }
    </div>
  </ng-container>
</app-base-modal>
